import { render } from "./portprojects.vue?vue&type=template&id=e3fb30cc"
import script from "./portprojects.vue?vue&type=script&lang=js"
export * from "./portprojects.vue?vue&type=script&lang=js"

import "./portprojects.vue?vue&type=style&index=0&id=e3fb30cc&lang=scss"

import exportComponent from "C:\\laragon\\www\\juani\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__